module.exports = __webpack_public_path__ + "static/media/instagram-iconTenerif.82530bd9.png";